// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__FMhxx","logout":"Auth_logout__SUvZD","authLink":"Auth_authLink__mqK4B","svg":"Auth_svg__+VxDF"};